import "../styles/App.css";

const BookCard = ({ book }) => {
  const currentLanguageVal = localStorage.getItem("language");
  const currentLanguage = currentLanguageVal ? currentLanguageVal : "en";
  return (
    <>
      <div className="book-card">
        <img
          className="book-card-image"
          src={`data:image/jpg;base64,${book.image}`}
          alt={book.title || "Book name"}
          height="250px"
          width="250px"
        />
        <div className="book-title">{currentLanguage === "en" ? book.title: book.title_hindi}</div>
      </div>
    </>
  );
};
export default BookCard;
